import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Função para decodificar JWT
const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

const WhatsAppLogin = () => {
  const { token } = useParams();

  useEffect(() => {
    if (token) {
      // Decodificar JWT para verificar flag newUser
      const decodedToken = decodeJWT(token);
      
      // Converter token WhatsApp em JWT
      fetch(`https://lucifer.grub.digital/public/whatsapp/verify-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token })
      })
      .then(response => response.json())
      .then(data => {
        if (data.success && data.token) {
          // Token WhatsApp válido - salvar JWT retornado
          const jwtToken = data.token;
          const isNewUser = data.usuario.newUser || false;
          
          localStorage.setItem('sitri_token', jwtToken);
          localStorage.setItem('sitri_user', JSON.stringify({
            id: data.usuario.id,
            nome: data.usuario.nome,
            cpf: data.usuario.cpf,
            telefone: data.usuario.telefone,
            email: data.usuario.email,
            newUser: isNewUser
          }));
          
          
          // Se é novo usuário, salvar flag para forçar captura de dados
          if (isNewUser) {
            localStorage.setItem('sitri_force_user_data', 'true');
          }
        } else {
        }
      })
      .catch((error) => {
      })
      .finally(() => {
        // Sempre redirecionar para delivery
        window.location.href = '/delivery';
      });
    } else {
      // Sem token - redirecionar para delivery
      window.location.href = '/delivery';
    }
  }, [token]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px'
    }}>
      Validando...
    </div>
  );
};

export default WhatsAppLogin;